import { Context, Config } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { CreateTemporaryUserDialog, TemporaryUserUtil } from '@leverege/api-ui-user-management';
import { Relationship, UserRoles } from '@leverege/molten-core';
import { GlobalState, UI } from '@leverege/ui-redux';
import { DataSources, Attributes } from '@leverege/ui-attributes';
import { AllowedReducer } from '@leverege/api-redux';
const {
  t,
  tf
} = I18N.ns('molten.imagine.actions.CreateTemporaryUserAction');
const create = ({
  relationship,
  molten
}) => {
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.CreateTemporaryUser`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    layout: {
      sort: 'visitor.createTemporaryUser',
      sectionName: t('sectionName', {
        blueprintName: blueprint.name
      })
    },
    prepare: async context => {
      const {
        clientProps: {
          dispatch
        }
      } = context;
      const target = Context.getTargetOfType(context, blueprint.type);
      if (!target) {
        return null;
      }
      const delegate = DataSources.getActions(target);
      const allowed = AllowedReducer.get(GlobalState.get(), delegate.id);
      if (typeof allowed?.createTemporaryUser !== 'boolean') {
        return dispatch(delegate.temporaryUsers().canCreate());
      }
      return null;
    },
    isPrepared: context => {
      const target = Context.getTargetOfType(context, blueprint.type);
      if (!target) {
        return true;
      }
      const delegate = DataSources.getActions(target);
      const allowed = AllowedReducer.get(GlobalState.get(), delegate.id);
      return typeof allowed?.createTemporaryUser === 'boolean';
    },
    handles: cxt => {
      const target = Context.getTargetOfType(cxt, blueprint.type);
      if (!target) {
        return false;
      }
      const delegate = DataSources.getActions(target);
      const allowed = AllowedReducer.get(GlobalState.get(), delegate.id);
      const can = allowed?.createTemporaryUser;
      return can === true;
    },
    appearance: ({
      context
    }) => {
      const target = Context.getTargetOfType(context, blueprint.type);
      const targetName = Attributes.get('name', blueprint.type, target.data);
      return {
        name: t('appearanceName', {
          blueprintName: blueprint.name,
          targetName
        }),
        icon: Config.get('VisitorActions', 'createIcon', 'fa fa-user-plus')
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          match
        }
      } = context;
      const target = Context.getTargetOfType(context, blueprint.type);
      const delegate = DataSources.getActions(target);
      const getResourceName = () => Attributes.get('name', blueprint.type, target.data);
      const allUserRoles = UI.get(GlobalState.get(), 'allUserRoles');
      const roleFilter = UserRoles.createTempUserRoleFilter(allUserRoles, Relationship.getResourceIdHierarchy(relationship, match), blueprint);
      const uiName = TemporaryUserUtil.getUiNameCalculator(molten.getConfig('uiName'));
      const uiUrl = TemporaryUserUtil.getUiUrlCalculator(window.location.origin);
      Dialogs.show({
        id: 'temporaryUserManagement.action.Create',
        component: CreateTemporaryUserDialog,
        props: {
          resourceId: delegate.id,
          projectId: molten.getConfig('api/projectId'),
          selectorProps: {
            simple: true,
            roleFilter
          },
          allowed: AllowedReducer.get(GlobalState.get(), delegate.id),
          actions: delegate,
          emailOptions: molten.getConfig('userManagement/emailOptions'),
          smsOptions: molten.getConfig('userManagement/smsOptions'),
          uiName,
          uiUrl,
          systemId: relationship.systemId,
          getResourceName
        }
      });
    }
  };
};
export default {
  create
};